import { render, staticRenderFns } from "./DepartmentPickerById.vue?vue&type=template&id=0d663844&"
import script from "./DepartmentPickerById.vue?vue&type=script&lang=js&"
export * from "./DepartmentPickerById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports